import { createSlice } from "@reduxjs/toolkit";
import { TestCase } from "@src/pages/student/data.type";

interface InitialState {
  trainerTestCases: TestCase[];
  trainerLabels: string[];
}

const initialState: InitialState = {
  trainerTestCases: [],
  trainerLabels: [],
};

const trainerTestCasesSlice = createSlice({
  name: "trainerTestCaseSlice",
  initialState: initialState,
  reducers: {
    setTestCasesTrainer: (state, action) => {
      state.trainerTestCases = action?.payload?.testCases?.map(
        (testCase: TestCase) => ({
          ...testCase,
          disabled: false,
        })
      );
      state.trainerLabels = action.payload.labels;
    },
    addTestCaseTrainer: (state, action) => {
      const newTestCase = state.trainerTestCases[action.payload.index || 0];
      state.trainerTestCases.push({
        ...newTestCase,
        disabled: false,
        canDelete: true,
      });
    },
    deleteTestCaseTrainer: (state, action) => {
      const index = action.payload.index;
      if (index >= 0 && index < state.trainerTestCases.length) {
        state.trainerTestCases.splice(index, 1);
      }
    },
    onInputChangeTrainer: (state, { payload }) => {
      state.trainerTestCases[payload.selectedTestCase].input[
        payload.selectedInput
      ] = payload.value;
    },
    onSqlSeedChangeTrainer: (state, { payload }) => {
      state.trainerTestCases[payload.selectedTestCase].seedSql =
        payload.seedSql;
    },
  },
});
export const {
  addTestCaseTrainer,
  onInputChangeTrainer,
  onSqlSeedChangeTrainer,
  setTestCasesTrainer,
  deleteTestCaseTrainer,
} = trainerTestCasesSlice.actions;
export default trainerTestCasesSlice.reducer;
